import Service from "../../Services";

const VenueHire = {
    namespaced: true,
    state: {
        venue_hire: null,
        venue_hire_type: null
    },
    mutations: {
        setVenueHire: (state, res) => {
            state.venue_hire = res;
        },
        setVenueHireType: (state, res) => {
            state.venue_hire_type = res;
        }
    },
    actions: {
        // eslint-disable-next-line no-unused-vars
        onGetVenueHire({ commit }, { lang, branch_id }) {
            return Service.VenueHireAPI.getVenueHire(lang, branch_id).then(res => {
                commit('setVenueHire', res);
                return res; // Ensure the response is returned
            }).catch(error => {
                console.error("Error in onGetVenueHire action:", error);
                throw error; // Ensure errors are propagated
            });
        },
        onGetVenueHireType({ commit }) {
            return Service.VenueHireAPI.getVenueHireType().then(res => {
                commit('setVenueHireType', res);
            });
        }

    },
}
export default VenueHire
